import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getStep } from './../../route-component';
import $ from 'jquery';
import common from './../../common';
import DesktopBudget from './DesktopBudget';
import FormationLabel from './FormationLabel';
import Jersey from './Jersey';
import NextBtn from './NextBtn';
import config from "../../config";
import {
    openMobilePlayerListing,
    setPlayerRecomendationFirstTimeFalse,
    showHidePlayerRecomendationPopUp,
    showPlayerRecomMobPopUp
} from './../../actions/FormationActions';
import ProgressBar from './ProgressBar';
import Heading from './Heading';
import MobileBudget from './MobileBudget';
import PlayerRecomendationPopUp from './filters/PlayerRecomendationPopUp'
import OutsideNotifier from '../../OutsideNotifier';

class PitchView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showRecomendationPopUp: false
        }
    }
    animateView = (target) => {
        if (target.length === 0) return;
        const BUFFER = 85;
        const topValue = $(target).offset().top - $('.si-actions-strip-sticky').height() - ($('.si-actions-tooltip').outerHeight() || 0) - BUFFER;
        $('html,body').animate({
            scrollTop: topValue
        }, 500);
    };
    animateSelectedInView = () => {
        // let rowMapArr = [{ "0":}]/
        let self = this;
        const tooltipElem = $('.si-more-opts').closest('.si-plyr-wrap');
        // const elem = $('.si-current');
        // const elem = $(".si-container.si-pitch-sections .si-team-row").each(function () {
        //     return $(this).attr("rowid") == 4;
        // })

        let elem = "";
        $(".si-container .si-pitch-sections .si-team-row").each(function () {
            if ($(this).attr("rowid") == self.props.currentPosition.rowIndex) {
                elem = $(this);
            }

        })
        if (self.props.currentPosition.rowIndex == 0) {
            elem = $(".si-subs-wrap .si-team-row");
        }


        if (tooltipElem.length === 0 && elem.length) {
            this.animateView(elem);
        }
    };
    handleNext = () => {
        if (this.props.teamData.captainID) {
            // return this.props.history.push('/select-badge');
            return this.props.history.push('/team-name');
        } else {
            return this.props.history.push('/select-captain');
        }
    };

    componentDidUpdate(prevProps) {
        const { mobilePlayerListingOpen, currentPosition } = this.props;
        if ((mobilePlayerListingOpen !== prevProps.mobilePlayerListingOpen) && mobilePlayerListingOpen) {
            const elem = $('.si-plyr-list-wrap');
            if (mobilePlayerListingOpen) {
                elem.off().on('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd', () => {
                    this.animateSelectedInView();
                });
            } else {
                elem.off();
            }
        } else {
            if (config.isMobile) {
                const { playerIndex, rowIndex, skill } = currentPosition;
                if (playerIndex !== prevProps.playerIndex ||
                    rowIndex !== prevProps.rowIndex ||
                    skill !== prevProps.skill) {
                    // this.animateSelectedInView();
                }
            }
        }
    }

    toHideListInMobile = (e) => {
        if (!$(e.target).closest('.si-plyr-wrap').length) {
            this.props.openMobilePlayerListing(false);
        }
    };

    componentWillMount() {
        $('html,body').animate({
            scrollTop: $(".si-main-component")
        }, 500);
    }

    showPopUp = (e) => {
        e.stopPropagation();
        common.customTracking('Select Player Recommendations Filter - Pitch', '/uclfantasy/create-team/');
        // show firsrt time pop up 
        if (this.props.IsFirstTimeRecomend) {
            //show Pop Up
            common.setLocalStorage('IsFirstTimeRecomend', false);
            this.props.setPlayerRecomendationFirstTimeFalse(false);
            this.props.showHidePlayerRecomendationPopUp(true);

        } else {
            //show drop down
            this.props.showPlayerRecomMobPopUp(true);
        }
        this.props.openMobilePlayerListing(true);
    }

    openPlayerListing = () => {
        if (this.props.showPlayerRecomMobPopUpFlag) {

        } else {
            common.customTracking('View Players - Pitch', '/uclfantasy/create-team/');
        }

        this.props.openMobilePlayerListing(true);
    }


    render() {
        const location = this.props.location;
        const teamData = this.props.teamData;
        const keysToDisplay = ['4', '3', '2', '1'];
        const keysToTest = ['0', '1', '2', '3', '4'];
        let pitchView = [];
        let subView = null;
        const shallProceed = keysToTest.every((key) => {
            return teamData.hasOwnProperty(key);
        });
        if (shallProceed) {
            pitchView = shallProceed && keysToDisplay.map((keyIndex) => {
                const posArray = teamData[keyIndex];
                const numOfPlayers = posArray.length;
                const numOfPlayersInWords = common.numToWord(numOfPlayers);
                const classN = 'si-row-' + numOfPlayersInWords;
                const players = posArray.map((player, index) => {
                    const isLast = index >= numOfPlayers / 2;
                    const isOdd = numOfPlayers % 2 !== 0;
                    const position = (isOdd && (Math.floor(numOfPlayers / 2) === index)) ? '' : isLast ? 'right' : 'left';
                    return <Jersey player={ player } key={ index } index={ index } objKey={ keyIndex } position={ position } numOfPlayers={ numOfPlayers } />
                });
                return <div className={ "si-team-row si-flexBox " + classN } key={ keyIndex } rowid={ keyIndex }>{ players }</div>
            });
            const benchArray = teamData['0'];
            const numOfPlayers = benchArray.length;
            const numOfPlayersInWords = common.numToWord(numOfPlayers);
            const classN = 'si-row-' + numOfPlayersInWords;
            let players = benchArray.map((player, index) => {
                const isLast = index >= numOfPlayers / 2;
                const isOdd = numOfPlayers % 2 !== 0;
                const position = (isOdd && (Math.floor(numOfPlayers / 2) === index)) ? '' : isLast ? 'right' : 'left';
                return <Jersey player={ player } key={ index } index={ index } objKey={ 0 } position={ position } numOfPlayers={ numOfPlayers } />
            });
            subView = <div className={ "si-team-row si-flexBox " + classN }>{ players }</div>
        }
        const handler = (config.isMobile && this.props.mobilePlayerListingOpen) ? { onClick: (e) => this.toHideListInMobile(e) } : {};
        let isDisabled = (teamData.playerCount < config.MAX_PLAYERS_PER_TEAM) || (teamData.budget < 0);
        if (getStep(location.pathname) === 1) {
            isDisabled = (this.props.teamData.captainID === null);
        }
        return <div className="si-pitch-view-wrap">

            {
                (getStep(location.pathname) != 5)
                    ?
                    <div className="si-top-section si-web">
                        <ProgressBar />
                        <Heading title={ this.props.location.pathname == "/select-captain" ? this.props.trans['choose_your_captain'] : this.props.trans['pick_your_players'] } { ...{ isDisabled } }
                            text={ this.props.trans.next }
                            showTitle={ isDisabled }
                            captainText={ this.props.location.pathname == "/select-captain" ? this.props.trans['captain_will_get'] : null }
                            tooltipText={ this.props.trans['select_your_team'] }
                            handler={ () => this.handleNext() } />
                        <MobileBudget />
                    </div>
                    :
                    null
            }


            { getStep(location.pathname) === 0 ? <DesktopBudget /> : null }
            <div className="si-container si-pitch-sections"  { ...handler }>{ pitchView }
                { (getStep(location.pathname) === 0 && (config.isMobile ? !this.props.mobilePlayerListingOpen : true)) ?
                    <FormationLabel /> : null }
            </div>
            <div className="si-subs-wrap">
                <div className="si-container">
                    { subView }
                </div>
            </div>
            {
                (getStep(location.pathname) != 5)
                    ?
                    ((this.props.toShowList && !this.props.isDisabled) || getStep(location.pathname) === 1) ? <div className="si-btn-wrp">
                        <NextBtn isDisabled={ this.props.isDisabled }
                            text={ this.props.trans.next }
                            showTitle={ this.props.isDisabled }
                            tooltipText={ this.props.trans['select_your_team'] }
                            handler={ () => this.handleNext() } />
                    </div> : <div className="si-btn-wrp si-dual-btn" onClick={ () => this.openPlayerListing() }>
                            <div className="si-btn si-btn-secondary">
                                <span>{ this.props.trans.viewPlayers }</span>
                            </div>
                            { this.props.playerRecomendation ? <div className="si-suggest-box" onClick={ (e) => { this.showPopUp(e) } }>
                                <i className="icon-ucl-new-filter"></i>
                                { this.props.IsFirstTimeRecomend ? <span className="si-suggest-new si-flexBox">{ this.props.trans.new ? this.props.trans.new : "New" }</span> : null }
                            </div> : null }
                        </div> : null }
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        teamData: state.formationData.teamData,
        mobilePlayerListingOpen: state.formationData.mobilePlayerListingOpen,
        currentPosition: state.formationData.currentPosition,
        playerRecomendation: state.formationData.playerRecomendation,
        IsFirstTimeRecomend: state.formationData.IsFirstTimeRecomend,
        showPlayerRecomMobPopUpFlag: state.formationData.showPlayerRecomMobPopUpFlag,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        openMobilePlayerListing: (bool) => dispatch(openMobilePlayerListing(bool)),
        setPlayerRecomendationFirstTimeFalse: () => dispatch(setPlayerRecomendationFirstTimeFalse()),
        showHidePlayerRecomendationPopUp: (bool) => dispatch(showHidePlayerRecomendationPopUp(bool)),
        showPlayerRecomMobPopUp: (bool) => dispatch(showPlayerRecomMobPopUp(bool))
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PitchView));


// WEBPACK FOOTER //
// ./src/components/onboarding/PitchView.js